// components/dnd/board/task-board/task-board.component.jsx
import React, { useEffect, useState, useMemo } from "react";
import { Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import {
  db,
  updateTaskAsDone,
  fieldValue,
  deleteTask,
  addTaskLabel,
  deleteTaskLabel,
} from "../../../../firebase/firebase.utils";
import { useNavigate, useParams } from "react-router-dom";
import {
  personFilterFunction,
  statusFilterFunction,
  timeFilterFunction,
  setTaskClassDone,
  autoUpdateTasksToUser,
  filterLogicFunction,
} from "../../task.util";
import "./task-board.styles.scss";
import { ContextMenu } from "../../../context-menu/ContextMenu";
import { contextMenuItems } from "../../../context-menu/menus/contextMenuItems";
import LoadModule from "../../../modules/load-module.component.jsx/load-module.component";
import Subtasks from "../../subtasks/subtasks.component";
import { FiSquare, FiCheckSquare } from "react-icons/fi";
import Labels from "../../../note-detail/labels/labels.component";
const TaskBoard = ({
  task,
  index,
  status,
  multiSelectMode,
  setMultiSelectMode,
  multiSelectItems,
  setMultiSelectItems,
  stationTasksFL,
}) => {
  const activeModules = useSelector((state) => state.space.activeModulesData);
  const users = useSelector((state) => state.user.users);
  const currentUser = useSelector((state) => state.user.currentUser);
  const filter = useSelector((state) => state.filter);
  const activeSpaceId = useSelector((state) => state.history.spaceId);
  const activeStationId = useSelector((state) => state.history.stationId);
  const taskref = stationTasksFL.find((item) => item.id === task) || {};
  const taskdone = Boolean(taskref.done);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [activeEvent, setActiveEvent] = useState({});
  const [taskClass, setTaskClass] = useState("");
  const { taskId } = useParams();
  const [activeItem, setActiveItem] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [multiselectedItem, setMultiSelectedItem] = useState(false);
  const labels = taskref.labels || [];
  const [label, setLabel] = useState("");
  const navigate = useNavigate();
  const handleCloseModal = () => {
    setModalIsOpen(false);
    setModalMode("");
    setActiveEvent({});
  };
  const handleEventClick = (taskref, event) => {
    if (!taskref?.id) return;
    if (multiSelectMode) {
      const selected = multiSelectItems.some((item) => item.id === taskref.id);
      setMultiSelectItems(
        selected
          ? multiSelectItems.filter((item) => item.id !== taskref.id)
          : [...multiSelectItems, taskref],
      );
      setMultiSelectedItem(!selected);
      return;
    }
    const rect = event.currentTarget.closest(".task").getBoundingClientRect();
    navigate(`task/${taskref.id}`, {
      state: {
        taskOrigin: {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        },
      },
    });
  };
  useEffect(() => {
    autoUpdateTasksToUser(users, task);
    setTaskClass(setTaskClassDone(task));
  }, [task]);
  // useEffect(() => {
  //   setFilterLogic(filterLogicFunction(statusFilter, timeFilter, personFilter));
  // }, [statusFilter, timeFilter, personFilter]);
  const taskrefinfo = {
    fromSpaceId: activeSpaceId,
    fromStationId: activeStationId,
    id: task,
    done: !taskdone,
  };
  const handleCheck = () => {
    document.getElementById("done_tone").play();
    if (taskdone) {
      updateTaskAsDone(activeSpaceId, activeStationId, task, false);
    } else {
      updateTaskAsDone(activeSpaceId, activeStationId, task, true);
    }
    if (taskref.assign) {
      const assignedUserRef = db.collection("users").doc(taskref.assign);
      assignedUserRef.get().then((userRefData) => {
        let assignedTasks = userRefData.data().assignedTasks;
        const findIndex = assignedTasks.findIndex((item) => item.id === task);
        assignedUserRef.update({
          assignedTasks: fieldValue.arrayRemove(assignedTasks[findIndex]),
        });
        assignedUserRef.update({
          assignedTasks: fieldValue.arrayUnion(taskrefinfo),
        });
      });
    }
  };
  const onRightClick = (event, taskref) => {
    event.preventDefault();
    const top = event.clientY;
    const left = event.clientX;
    setActiveItem(taskref);
    setShowContextMenu(true);
    setContextMenuPosition({ top, left });
  };
  const onContextMenuItemClick = (menuItemLabel) => {
    switch (menuItemLabel) {
      case "Multiselect":
        console.log("clicled MultiSelect");
        setMultiSelectMode(!multiSelectMode);
        console.log("MultiSelect Mode is", multiSelectMode);
        // setListData(listData.filter((item) => item.id !== activeItem));
        break;
      case "Delete":
        console.log("clicled Delete");
        // setListData(listData.filter((item) => item.id !== activeItem));
        if (multiSelectMode) {
          multiSelectItems.forEach((item) => {
            deleteTask(
              item.fromSpaceId,
              item.fromStationId,
              item.phase,
              currentUser.uid,
              item,
            );
          });
        } else
          deleteTask(
            activeItem.fromSpaceId,
            activeItem.fromStationId,
            activeItem.phase,
            currentUser.uid,
            activeItem,
          );
        break;
      case "Copy":
        console.log("Copy done");
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const closeContextMenu = () => setShowContextMenu(false);
    window.addEventListener("click", closeContextMenu);
    return () => window.removeEventListener("click", closeContextMenu);
  }, []);
  const handleLabelSubmit = (e) => {
    e.preventDefault();
    if (label !== "") {
      addTaskLabel(
        taskref.fromSpaceId,
        taskref.fromStationId,
        taskref.id,
        label,
      );
    }
    setLabel("");
  };
  const handleRemoveLabel = (lbl) => {
    //arrayremove
    deleteTaskLabel(
      taskref.fromSpaceId,
      taskref.fromStationId,
      taskref.id,
      lbl,
    );
  };
  return (
    <Draggable draggableId={task} index={index}>
      {(provided, snapshot) => {
        const style = {
          ...provided.draggableProps.style,
          opacity: status.open ? "1" : "0",
          height: status.open ? "auto" : "10px",
        };
        return (
          <div
            {...provided.draggableProps}
            ref={provided.innerRef}
            className="task__logic"
          >
            {stationTasksFL.findIndex((item) => item.id === task) !== -1 && (
              <div
                className={`task ${taskClass}`}
                {...provided.dragHandleProps}
                style={{
                  border:
                    (taskId === task || multiselectedItem) &&
                    "1px solid #34b5e4",
                  background:
                    (taskId === task || multiselectedItem) &&
                    " rgba(52, 181, 228, 0.05)",
                }}
              >
                <div
                  className="task__expandPlace"
                  onClick={(event) => handleEventClick(taskref, event)}
                  onContextMenu={(event) => onRightClick(event, taskref)}
                />
                <div className="task__header">
                  <div className="task__taskName">
                    {/* <p>{task}</p> */}
                    <div
                      className={
                        taskref.done ? "task__card-done" : "task__card"
                      }
                    >
                      {/* <input type="checkbox"></input> */}
                      <i onClick={handleCheck}>
                        {taskref.done ? <FiCheckSquare /> : <FiSquare />}
                      </i>
                      <audio
                        id="done_tone"
                        src="/media/mixkit-cool-interface-click-tone-2568.wav"
                      ></audio>
                      <p>{taskref.title}</p>
                    </div>
                    {/* <TaskPullInfo task={task} /> */}
                  </div>
                  {/* <CheckBox task={task} style={{ opacity: task.done ? 1 : 0 }} /> */}
                </div>
                <Subtasks task={taskref} />
                <div
                  style={{
                    marginBottom: 10,
                    marginTop: 5,
                    paddingLeft: 20,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Labels
                    labels={labels}
                    handleLabelSubmit={handleLabelSubmit}
                    handleRemoveLabel={handleRemoveLabel}
                    setLabel={setLabel}
                    label={label}
                  />
                </div>
                <div className="task__modules">
                  {activeModules?.map((module) => {
                    return (
                      <LoadModule
                        module={module}
                        key={module.name}
                        task={taskref}
                        style="box"
                      />
                    );
                  })}
                </div>
                {showContextMenu && (
                  <ContextMenu
                    top={contextMenuPosition.top}
                    left={contextMenuPosition.left}
                    menuItems={contextMenuItems}
                    onMenuItemClick={onContextMenuItemClick}
                  />
                )}
              </div>
            )}
          </div>
        );
      }}
    </Draggable>
  );
};
export default TaskBoard;
